module.exports = __webpack_public_path__ + "static/media/annotationActive.2ba13c37.png";